type ModalContent = string | React.ReactNode | Array<any>
type ModalType = 'success' | 'info' | 'warning' | 'danger'

export interface IModal {
  message: ModalContent
  header?: ModalContent
  variant?: ModalType
  onAgree?: () => void
}

export interface IAction {
  type: string
  payload: any
}

export const toggleModal = (options?: IModal) => {
  const action: IAction = {
    type: 'TOGGLE_MODAL',
    payload: null
  }
  if (options) action.payload = options
  return action
}

